import { UserActions } from '../actions/actionTypes'
import { UserInterface } from '../Interfaces/UserInterface'
import { ReducerBuilder } from './ReducerBuilder'

export const INITIAL_STATE: UserInterface = {
  id: null,
  email: null,
  isIdpUser: null,
  identities: [],
}

type StateType = UserInterface | null
type PayloadType = UserInterface

function assignUser(state: StateType, payload: PayloadType): StateType {
  return { ...payload }
}

const reducer = ReducerBuilder.create<StateType, PayloadType | string>(INITIAL_STATE)
  .mapAction(UserActions.GET_USER, assignUser)
  .build()

export default reducer
